<template>
  <div id="quoterequest">
    <QuoteForm />
  </div>
</template>

<script lang="ts">
import QuoteForm from "@/components/global-components/QuoteForm.vue";

export default {
  components: { QuoteForm },
  name: "QuoteRequestView",
  data: () => ({}),
};
</script>
